export default "__VITE_ASSET__4c2a1032__"